/**
 * VARIANT IMAGE FILTER v6.8
 * Filtra imagens baseado no ALT TEXT das imagens
 * EXECUCAO IMEDIATA - sem delays para evitar flash
 *
 * REQUISITO: As imagens devem ter o nome EXATO da cor no alt text
 * Exemplo: alt="Azul Marinho" (NAO apenas "Azul")
 *
 * v6.8: FIX CRITICO - removido stopPropagation() que bloqueava TODOS os handlers
 *       do tema (botao comprar, preco, inventario). Agora usa patch cirurgico
 *       no product-media para evitar conflito, sem bloquear outros handlers.
 * v6.7: FIX DEFINITIVO - usa carousel.reload() do tema (destroy+recreate Flickity)
 * v6.6: FIX tema removia is-filtered ao trocar variante (capture phase)
 * v6.3: cellSelector, sem remocao de DOM
 * v6.1: Contador mobile dinamico "1/4"
 * v6.0: Limite de 4 imagens por cor
 *
 * Imagens SEM cor no alt sao ocultadas
 * Apenas imagens com keywords especificas (tabela, medidas, etc) sao mostradas para todas as cores
 */

(function() {
  'use strict';

  var DEBUG = true;
  var MAX_VISIBLE_IMAGES = 4;
  var COLOR_OPTION_NAMES = ['cor', 'color', 'colour', 'cores', 'colors'];
  var GENERIC_KEYWORDS = ['tabela', 'medidas', 'size', 'chart', 'guia', 'guide', 'sizing'];

  function log() {
    if (DEBUG) {
      var args = ['%c[VariantFilter]', 'color: #4CAF50; font-weight: bold;'];
      for (var i = 0; i < arguments.length; i++) args.push(arguments[i]);
      console.log.apply(console, args);
    }
  }

  function isMobile() {
    return window.innerWidth < 1000;
  }

  function getCarouselElement() {
    return document.querySelector('flickity-carousel.product__media-list');
  }

  function normalizeText(text) {
    if (!text) return '';
    return text
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[-_]/g, ' ')
      .replace(/\s+\d+$/g, '')
      .replace(/\s+/g, ' ')
      .trim();
  }

  var productData = null;
  var colorOptionIndex = -1;
  var allColors = [];
  var isFirstFilter = true;
  var originalFlickityConfig = null;

  /* ========================================================================
   * v6.8: PATCH CIRURGICO NO PRODUCT-MEDIA
   * Desativa o handler nativo de variant:changed do product-media
   * SEM usar stopPropagation (que bloqueava botao comprar, preco, etc.)
   * ====================================================================== */
  function patchProductMedia() {
    if (!window.customElements || !window.customElements.get('product-media')) {
      setTimeout(patchProductMedia, 100);
      return;
    }
    var ProductMediaClass = window.customElements.get('product-media');
    if (!ProductMediaClass) return;

    var original = ProductMediaClass.prototype._onVariantChanged;
    if (original) {
      ProductMediaClass.prototype._onVariantChanged = function(event) {
        if (colorOptionIndex >= 0) {
          log('product-media._onVariantChanged bypassed (variant-filter active)');
          return;
        }
        return original.call(this, event);
      };
      log('product-media patched (variant handler bypassed when filter active)');
    }
  }

  /* ========================================================================
   * MOBILE SLIDES
   * ====================================================================== */

  function reloadCarouselWithConfig(cellSelector) {
    var carousel = getCarouselElement();
    if (!carousel) return;

    var config = Object.assign({}, originalFlickityConfig);
    config.cellSelector = cellSelector;
    carousel.setAttribute('flickity-config', JSON.stringify(config));

    if (typeof carousel.reload === 'function') {
      carousel.reload().then(function() {
        log('carousel.reload() completo, cellSelector:', cellSelector);
        var visibleItems = carousel.querySelectorAll(cellSelector);
        updateMobileCounter(visibleItems.length, 1);
        flickityListenerAttached = false;
        setTimeout(function() { attachFlickityListener(); }, 200);
      }).catch(function(e) {
        log('carousel.reload() erro (tentando fallback):', e);
        try { carousel.reload(); } catch(e2) {}
      });
    } else {
      log('carousel.reload nao disponivel, fallback manual');
      fallbackReload(carousel, cellSelector);
    }
  }

  function fallbackReload(carousel, cellSelector) {
    var flickity = getFlickityInstance();
    if (!flickity) return;
    flickity.options.cellSelector = cellSelector;
    flickity.reloadCells();
    flickity.resize();
    flickity.select(0, false, true);
    var visibleItems = carousel.querySelectorAll(cellSelector);
    updateMobileCounter(visibleItems.length, 1);
  }

  function getFlickityInstance() {
    var carousel = getCarouselElement();
    if (!carousel) return null;
    if (window.ThemeFlickity && typeof window.ThemeFlickity.data === 'function') {
      var instance = window.ThemeFlickity.data(carousel);
      if (instance && instance.options) return instance;
    }
    if (window.Flickity && typeof window.Flickity.data === 'function') {
      var instance2 = Flickity.data(carousel);
      if (instance2 && instance2.options) return instance2;
    }
    return (carousel._flickity && carousel._flickity.options) ? carousel._flickity : null;
  }

  function restoreSlidesForMobile() {
    var carousel = getCarouselElement();
    if (!carousel) return;

    carousel.querySelectorAll('.product__media-item').forEach(function(item) {
      item.classList.remove('is-filtered', 'is-over-limit');
    });

    log('restoreSlidesForMobile: classes removidas');
  }

  function filterSlidesForMobile() {
    var selector = '.product__media-item:not(.is-filtered):not(.is-over-limit)';

    requestAnimationFrame(function() {
      reloadCarouselWithConfig(selector);
    });
  }

  function updateMobileCounter(total, current) {
    if (current === undefined) current = 1;
    var wrapper = document.querySelector('.product__media-list-wrapper');
    if (wrapper) {
      wrapper.setAttribute('data-total', total);
      wrapper.setAttribute('data-current', current);
    }

    var counterCurrent = document.querySelector('.product__media-counter-current');
    var counterTotal = document.querySelector('.product__media-counter-total');

    if (counterCurrent) counterCurrent.textContent = current;
    if (counterTotal) counterTotal.textContent = total;

    log('Counter updated:', current, '/', total);
  }

  /* ========================================================================
   * FLICKITY SLIDE CHANGE LISTENER
   * ====================================================================== */
  var flickityListenerAttached = false;

  function attachFlickityListener() {
    if (flickityListenerAttached) return;

    var carousel = getCarouselElement();
    if (!carousel) return;

    var observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
          var target = mutation.target;
          if (target.classList.contains('product__media-item') && target.classList.contains('is-selected')) {
            updateCounterFromSelectedSlide();
          }
        }
      });
    });

    observer.observe(carousel, {
      attributes: true,
      subtree: true,
      attributeFilter: ['class']
    });

    var flickity = getFlickityInstance();
    if (flickity && typeof flickity.on === 'function') {
      flickity.on('change', function(index) {
        log('Flickity change:', index);
        updateCounterFromIndex(index);
      });
      flickity.on('select', function(index) {
        log('Flickity select:', index);
        updateCounterFromIndex(index);
      });
    }

    carousel.addEventListener('touchend', function() {
      setTimeout(updateCounterFromSelectedSlide, 150);
    });
    carousel.addEventListener('mouseup', function() {
      setTimeout(updateCounterFromSelectedSlide, 150);
    });

    /* [PATCH 2026-05-13] Listener defensivo no evento DOM emitido pelo
       <flickity-carousel> do tema (theme.js triggerEvent — detail = índice
       numérico que o Flickity passa ao callback 'change'/'settle').
       Garante atualização do contador mesmo se Flickity.data() não
       conseguir resolver a instância. */
    carousel.addEventListener('flickity:slide-changed', function(e) {
      log('flickity:slide-changed DOM event, detail:', e.detail);
      var idx = (typeof e.detail === 'number') ? e.detail
              : (e.detail && typeof e.detail.index === 'number') ? e.detail.index
              : null;
      if (idx !== null) {
        updateCounterFromIndex(idx);
      } else {
        updateCounterFromSelectedSlide();
      }
    });
    carousel.addEventListener('flickity:slide-settled', function() {
      updateCounterFromSelectedSlide();
    });

    /* [PATCH 2026-05-13] FALLBACK FINAL — polling do item selecionado no mobile.
       Roda 4×/s e detecta mudança no índice do item com .is-selected ou
       aria-current. Mais barato que MutationObserver em alguns navegadores
       mobile e à prova de qualquer falha de evento. */
    if (window.innerWidth < 1000 && !window.__variantFilterCounterPoller) {
      var lastIdx = -1;
      window.__variantFilterCounterPoller = setInterval(function() {
        var visible = document.querySelectorAll('.product__media-item:not(.is-filtered):not(.is-over-limit)');
        if (!visible.length) return;
        var selected = -1;
        for (var i = 0; i < visible.length; i++) {
          var el = visible[i];
          if (el.classList.contains('is-selected') || el.getAttribute('aria-current') === 'true') {
            selected = i;
            break;
          }
        }
        if (selected !== -1 && selected !== lastIdx) {
          lastIdx = selected;
          updateMobileCounter(visible.length, selected + 1);
        }
      }, 250);
    }

    flickityListenerAttached = true;
    log('Flickity listener attached');
  }

  function updateCounterFromSelectedSlide() {
    var visibleItems = document.querySelectorAll('.product__media-item:not(.is-filtered):not(.is-over-limit)');
    var selectedItem = document.querySelector('.product__media-item.is-selected:not(.is-filtered):not(.is-over-limit)');

    if (!selectedItem || visibleItems.length === 0) return;

    var currentIndex = 1;
    visibleItems.forEach(function(item, index) {
      if (item === selectedItem) {
        currentIndex = index + 1;
      }
    });

    updateMobileCounter(visibleItems.length, currentIndex);
  }

  function updateCounterFromIndex(flickityIndex) {
    var visibleItems = document.querySelectorAll('.product__media-item:not(.is-filtered):not(.is-over-limit)');
    if (visibleItems.length === 0) return;

    var idx = Math.max(0, Math.min(flickityIndex, visibleItems.length - 1));
    updateMobileCounter(visibleItems.length, idx + 1);
  }

  /* ========================================================================
   * CARREGAMENTO DE DADOS
   * ====================================================================== */
  function loadProductData() {
    var productJson = document.querySelector('[data-product-json]');
    if (productJson) {
      try {
        productData = JSON.parse(productJson.textContent);
        log('Product loaded:', productData.title);
      } catch (e) {
        log('Error parsing product JSON:', e);
        return false;
      }
    }

    if (!productData) {
      log('No product data found');
      return false;
    }

    for (var i = 0; i < productData.options.length; i++) {
      var optionName = (productData.options[i].name || '').toLowerCase();
      if (COLOR_OPTION_NAMES.indexOf(optionName) !== -1) {
        colorOptionIndex = i;
        allColors = productData.options[i].values.map(function(v) { return normalizeText(v); });
        break;
      }
    }

    if (colorOptionIndex === -1) {
      log('No color option found');
      return false;
    }

    log('Color option index:', colorOptionIndex);
    log('All colors:', allColors);

    return true;
  }

  /* ========================================================================
   * CORRESPONDENCIA DE CORES
   * ====================================================================== */
  function colorsMatch(colorA, colorB) {
    if (!colorA || !colorB) return false;
    return colorA === colorB;
  }

  function imageMatchesColor(imgAlt, selectedColor) {
    var normalizedAlt = normalizeText(imgAlt);
    var normalizedColor = normalizeText(selectedColor);
    if (!normalizedAlt || !normalizedColor) return false;
    return colorsMatch(normalizedAlt, normalizedColor);
  }

  function isGenericImage(imgAlt) {
    var normalizedAlt = normalizeText(imgAlt);
    if (!normalizedAlt) return false;
    return GENERIC_KEYWORDS.some(function(keyword) { return normalizedAlt.indexOf(keyword) !== -1; });
  }

  /* ========================================================================
   * ATUALIZACAO DO LAYOUT
   * ====================================================================== */
  function updateGridLayout(visibleCount) {
    var carousel = getCarouselElement();
    var slider = document.querySelector('.flickity-slider');

    if (!carousel && !slider) return;

    var container = carousel || slider.parentElement;

    container.classList.remove('grid-1', 'grid-2', 'grid-3', 'grid-4plus');

    if (visibleCount === 1) {
      container.classList.add('grid-1');
    } else if (visibleCount === 2) {
      container.classList.add('grid-2');
    } else if (visibleCount === 3) {
      container.classList.add('grid-3');
    } else {
      container.classList.add('grid-4plus');
    }

    log('Grid layout updated:', visibleCount, 'images');
  }

  /* ========================================================================
   * FILTRO PRINCIPAL
   * ====================================================================== */
  function filterImages(selectedColor) {
    log('Filtering for color:', selectedColor, '(max:', MAX_VISIBLE_IMAGES, 'images)');

    if (isMobile()) {
      restoreSlidesForMobile();
    }

    var mediaItems = document.querySelectorAll('.product__media-item');
    var thumbnails = document.querySelectorAll('.product__thumbnail-item, .dots-nav__item');

    if (mediaItems.length === 0) {
      log('No media items found');
      return;
    }

    mediaItems.forEach(function(item) {
      item.classList.remove('first-visible', 'is-filtered', 'is-over-limit');
    });

    var visibleCount = 0;
    var colorMatchCount = 0;
    var firstVisibleItem = null;

    mediaItems.forEach(function(item) {
      var img = item.querySelector('img');
      var imgAlt = img ? (img.alt || '') : '';

      var matchesColor = imageMatchesColor(imgAlt, selectedColor);
      var isGeneric = isGenericImage(imgAlt);
      var shouldShowByColor = matchesColor || isGeneric;

      if (shouldShowByColor) {
        if (matchesColor) {
          colorMatchCount++;
        }

        var exceedsLimit = matchesColor && colorMatchCount > MAX_VISIBLE_IMAGES;

        if (exceedsLimit) {
          item.classList.add('is-over-limit');
          log('  LIMIT:', imgAlt.substring(0, 40), '| #' + colorMatchCount);
        } else {
          visibleCount++;
          if (!firstVisibleItem) {
            firstVisibleItem = item;
            item.classList.add('first-visible');
          }
          log('  SHOW:', imgAlt.substring(0, 40), '| color:', matchesColor, '| generic:', isGeneric);
        }
      } else {
        item.classList.add('is-filtered');
        log('  HIDE:', imgAlt.substring(0, 40));
      }
    });

    thumbnails.forEach(function(thumb) {
      var mediaId = thumb.getAttribute('data-media-id');
      var correspondingItem = document.querySelector('.product__media-item[data-media-id="' + mediaId + '"]');

      if (correspondingItem) {
        var isHidden = correspondingItem.classList.contains('is-filtered') ||
                       correspondingItem.classList.contains('is-over-limit');
        thumb.classList.toggle('is-filtered', isHidden);
      }
    });

    log('Visible:', visibleCount, '/', mediaItems.length);

    if (visibleCount === 0) {
      log('No visible images - showing first', MAX_VISIBLE_IMAGES);
      showFirstNImages(MAX_VISIBLE_IMAGES);
      return;
    }

    updateGridLayout(visibleCount);
    markAsReady();

    if (isMobile()) {
      filterSlidesForMobile();
    } else if (firstVisibleItem) {
      selectImage(firstVisibleItem);
    }
  }

  /* ========================================================================
   * FALLBACK
   * ====================================================================== */
  function showFirstNImages(n) {
    var mediaItems = document.querySelectorAll('.product__media-item');
    var thumbnails = document.querySelectorAll('.product__thumbnail-item, .dots-nav__item');

    var count = 0;

    mediaItems.forEach(function(item) {
      item.classList.remove('is-filtered', 'is-over-limit', 'first-visible');

      if (count < n) {
        count++;
        if (count === 1) {
          item.classList.add('first-visible');
        }
      } else {
        item.classList.add('is-over-limit');
      }
    });

    thumbnails.forEach(function(thumb) {
      var mediaId = thumb.getAttribute('data-media-id');
      var correspondingItem = document.querySelector('.product__media-item[data-media-id="' + mediaId + '"]');

      if (correspondingItem) {
        var isHidden = correspondingItem.classList.contains('is-over-limit');
        thumb.classList.toggle('is-filtered', isHidden);
      }
    });

    updateGridLayout(Math.min(n, mediaItems.length));
    markAsReady();

    if (isMobile()) {
      filterSlidesForMobile();
    }
  }

  function showAllImages() {
    document.querySelectorAll('.product__media-item, .product__thumbnail-item, .dots-nav__item')
      .forEach(function(item) { item.classList.remove('is-filtered', 'is-over-limit'); });

    if (isMobile()) {
      reloadCarouselWithConfig('.product__media-item');
    }

    markAsReady();
  }

  function markAsReady() {
    var mediaList = document.querySelector('.product__media-list');
    if (mediaList) {
      mediaList.classList.add('filter-ready');
      if (isFirstFilter) {
        isFirstFilter = false;
        requestAnimationFrame(function() {
          requestAnimationFrame(function() {
            mediaList.classList.add('transitions-enabled');
          });
        });
      }
    }
  }

  function selectImage(item) {
    var mediaId = item.getAttribute('data-media-id');
    var carousel = getCarouselElement();

    if (carousel && typeof carousel.select === 'function') {
      try {
        carousel.select('[data-media-id="' + mediaId + '"]');
      } catch (e) {}
    }
  }

  /* ========================================================================
   * EVENT HANDLERS
   * ====================================================================== */
  function onVariantChanged(event) {
    var variant = event.detail ? event.detail.variant : null;
    if (!variant) {
      showFirstNImages(MAX_VISIBLE_IMAGES);
      return;
    }

    log('Variant changed:', variant.title);

    var selectedColor = variant['option' + (colorOptionIndex + 1)];

    if (selectedColor) {
      filterImages(selectedColor);
    } else {
      showFirstNImages(MAX_VISIBLE_IMAGES);
    }
  }

  /* ========================================================================
   * INICIALIZACAO
   * ====================================================================== */
  function init() {
    log('Initializing v6.8 (max', MAX_VISIBLE_IMAGES, 'images per color)...');

    var carousel = getCarouselElement();
    if (carousel) {
      try {
        originalFlickityConfig = JSON.parse(carousel.getAttribute('flickity-config'));
        log('Original flickity config saved:', JSON.stringify(originalFlickityConfig));
      } catch (e) {
        log('Could not parse flickity-config, using defaults');
        originalFlickityConfig = {
          adaptiveHeight: true,
          dragThreshold: 10,
          initialIndex: 0,
          draggable: ">1",
          cellSelector: ".product__media-item",
          percentPosition: false,
          pageDots: false,
          prevNextButtons: false,
          wrapAround: true
        };
      }
    }

    if (!loadProductData()) {
      log('Init failed - showing first', MAX_VISIBLE_IMAGES, 'images only');
      showFirstNImages(MAX_VISIBLE_IMAGES);
      return;
    }

    // v6.8: Patch cirurgico no product-media em vez de stopPropagation
    // Isso permite que variant:changed chegue em TODOS os handlers (botao, preco, inventario)
    patchProductMedia();

    // v6.8: Listener SEM stopPropagation - outros handlers (botao comprar, preco) recebem o evento
    document.addEventListener('variant:changed', function(event) {
      onVariantChanged(event);
    }, true);

    // Filtro inicial
    var urlParams = new URLSearchParams(window.location.search);
    var variantId = urlParams.get('variant');

    var initialColor = null;

    if (variantId && productData && productData.variants) {
      var variant = productData.variants.find(function(v) { return String(v.id) === variantId; });
      if (variant) {
        initialColor = variant['option' + (colorOptionIndex + 1)];
      }
    }

    if (!initialColor) {
      var firstVariant = productData && productData.variants ? productData.variants[0] : null;
      if (firstVariant) {
        initialColor = firstVariant['option' + (colorOptionIndex + 1)];
      }
    }

    if (initialColor) {
      filterImages(initialColor);
    } else {
      showFirstNImages(MAX_VISIBLE_IMAGES);
    }

    setTimeout(function() {
      attachFlickityListener();
      updateMobileCounter(MAX_VISIBLE_IMAGES, 1);
    }, 500);

    log('Initialized successfully');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
